import { useEffect } from "react";

import { useLayoutStore } from "store/LayoutStore";

const PageLoader = () => {
  const onShowProgress = useLayoutStore((state) => state.onShowProgress);

  useEffect(() => {
    onShowProgress(true);

    return () => {
      onShowProgress(false);
    };
  }, [onShowProgress]);

  return null;
};

export default PageLoader;
